import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  private activitySubscription!: Subscription;
  private activityChannel: BroadcastChannel;

  constructor(private ngZone: NgZone) {
    this.activityChannel = new BroadcastChannel('activity_channel');
    this.initializeLocalStorage();
    this.setupActivityListeners();
    this.listenForActivity();
  }

  initializeLocalStorage() {
    if (!localStorage.getItem('lastActivity')) {
      const timestamp = new Date().getTime();
      localStorage.setItem('lastActivity', timestamp.toString());
    }
  }

  setupActivityListeners() {
    this.ngZone.runOutsideAngular(() => {
      const mouseMove$ = fromEvent(window, 'mousemove');
      const keyDown$ = fromEvent(window, 'keydown');
      const click$ = fromEvent(window, 'click');

      const activity$ = merge(mouseMove$, keyDown$, click$);

      this.activitySubscription = activity$.subscribe(() => {
        this.ngZone.run(() => {
          this.notifyActivity();
        });
      });
    });
  }

  notifyActivity() {
    const timestamp = new Date().getTime();
    localStorage.setItem('lastActivity', timestamp.toString());
    this.activityChannel.postMessage({ type: 'activity', timestamp });
  }

  listenForActivity() {
    this.activityChannel.onmessage = (event) => {
      if (event.data.type === 'activity') {
        const lastActivity = parseInt(localStorage.getItem('lastActivity') || '0', 10);
        if (event.data.timestamp > lastActivity) {
          localStorage.setItem('lastActivity', event.data.timestamp.toString());
        }
      }
    };
  }

  ngOnDestroy() {
    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
    }
    this.activityChannel.close();
  }
}
